



















































































import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import MStoreTable from '@/components/shared/Table/MStoreTable.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreFormSelect from '@/components/shared/MStoreFormSelect.vue';
import {
  DocuSignTemplateModel,
  DocuSignTemplatesConfigurationModel,
  DocumentTypeModel,
  Configuration,
  StickySettingsActions,
  StickyStoreNames,
  StickySettingsGetters,
  StickySettingsFields,
  StickyTableStateFields
} from '@/types';
import { RouteRegEx } from '@/types/enums';
import { DocuSignConfigurationService } from '@/services/docuSign/DocuSignConfigurationService';
import {
  ComponentHelper,
  MTablehelper,
  RouteHelpers,
  confirmationHelper,
  FormFieldValidation,
  ObjectHelper
} from '@/mixins';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { Dictionary } from 'node_modules/vue-router/types/router';

export default Vue.extend({
  name: 'DocuSignTemplateManagement',
  mixins: [ComponentHelper, MTablehelper, RouteHelpers, confirmationHelper, FormFieldValidation, ObjectHelper],
  data() {
    return {
      pageIsLoading: true,
      submitIsLoading: false,
      isLoading: false,
      fields: [
        {
          template: {
            label: 'Template',
            sortable: true
          }
        },
        {
          key: 'actions',
          label: '',
          sortable: false
        }
      ],
      items: [] as DocuSignTemplateModel[],
      hasError: false,
      errorMessage: '',
      documentTypes: [] as DocumentTypeModel[],
      docuSignTemplatesConfigurationModel: {} as DocuSignTemplatesConfigurationModel
    };
  },
  methods: {
    ...mapActions(StickyStoreNames.DocuSignTemplateManagement, [
      StickySettingsActions.SetStickyStateField,
      StickySettingsActions.ResetStickyState
    ]),
    async getData(this: any) {
      this.isLoading = true;
      try {
        this.docuSignTemplatesConfigurationModel = await DocuSignConfigurationService.getTemplatesConfigurationAsync({
          documentTypeId: this.documentTypeId
        } as DocuSignTemplatesConfigurationModel);
        this.items = this.docuSignTemplatesConfigurationModel.templates;
        this.documentTypes = this.docuSignTemplatesConfigurationModel.documentTypes;
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },
    navigateToEditTemplate(this: any, id: number) {
      const param = {} as Dictionary<any>;
      param.documentTypeId = this.documentTypeId;
      param.id = id;
      this.onTableStateFieldUpdated('selectedPk', id);
      this.$router.push({
        name: Configuration.DocuSign.Template.Edit.name,
        params: param
      });
    },
    navigateToAddTemplate(this: any) {
      const param = {} as Dictionary<any>;
      param.documentTypeId = this.documentTypeId;
      this.$router.push({
        name: Configuration.DocuSign.Template.Add.name,
        params: param
      });
    },
    async deleteTemplate(this: any, id: number) {
      const result = await this.hasDeleteConfirmedAsync(
        this.$bvModal,
        'Are you sure you want to delete the template?'
      );
      if (result) {
        try {
          this.isLoading = true;
          await DocuSignConfigurationService.deleteTemplateAsync(id);
          SnotifyConfiguration.showSuccess('Template deleted successfully.');
          await this.getData();
        } catch (error) {
          this.$log('Error deleting Template');
        } finally {
          this.isLoading = false;
        }
      }
    },
    onTableStateFieldUpdated(this: any, field: string, value: any) {
      this.setStickyStateField({
        field: `tableState.${field}`,
        value
      });
    },
    resetViewState(this: any) {
      const canKeepState = this.canKeepState(RouteRegEx.DocuSignTemplates);
      if (!canKeepState) {
        this.resetStickyState();
      }
    },
    async initialise(this: any) {
      try {
        this.pageIsLoading = true;
        this.resetViewState();
        await this.getData();
      } catch (error) {
        this.handleError(error);
      } finally {
        this.pageIsLoading = false;
      }
    }
  },
  computed: {
    ...mapGetters(StickyStoreNames.DocuSignTemplateManagement, [StickySettingsGetters.GetStickyStateField]),
    getDocumentTypeId(this: any): number | null {
      return this.getStickyStateField ? this.getStickyStateField(StickySettingsFields.DocumentTypeId) : null;
    },
    documentTypeId: {
      get(this: any): number | null {
        const documentTypeId = this.getDocumentTypeId;
        if (documentTypeId !== null) {
          return documentTypeId;
        }
        return this.docuSignTemplatesConfigurationModel
          ? this.docuSignTemplatesConfigurationModel.documentTypeId
          : null;
      },
      set(this: any, value: any) {
        this.setStickyStateField({ field: StickySettingsFields.DocumentTypeId, value });
      }
    },
    tableHeaderText(this: any) {
      const documentType = this.docuSignTemplatesConfigurationModel?.documentTypes?.find(
        (x: DocumentTypeModel) => x.id === this.documentTypeId
      );
      return documentType ? `Template Management (${documentType.description})` : 'Template Management';
    },
    stickyTableStateFields() {
      return StickyTableStateFields;
    }
  },
  watch: {
    async documentTypeId(this: any, documentTypeId: number | undefined, previousDocumentTypeId) {
      if (previousDocumentTypeId == null) {
        return;
      }
      this.getData();
    }
  },
  components: {
    MStoreTable,
    LoadingSpinner,
    MStoreFormSelect
  },
  mounted() {
    this.initialise();
  }
});
